import Notify from "../classes/notify";

export default class CustomClipboard {
	constructor() {
		this.selectOnFocusClass = '.js-select-on-focus',
		this.clipboardAttr = '[data-clipboard=true]',
		this.clipboardAttrHtml = '[data-clipboard-html=true]',
		this.notify = new Notify();

		this.initialize();
	}

	initializeClipboard() {
		const that = this;

		const clipboard = new Clipboard(this.clipboardAttr);

		clipboard.on('success', function (event) {
			that.notifyOnSuccess(event)
		});
	}

	initializeHtmlClipboard() {
		const that = this;

		const clipboard = new Clipboard(this.clipboardAttrHtml, {
			text: function (trigger) {
				const dataTarget = trigger.getAttribute('data-clipboard-target');

				const html = document.querySelector(dataTarget);

				return html.innerHTML;
			}
		});

		clipboard.on('success', function (event) {
			that.notifyOnSuccess(event)
		});
	}

	selectOnFocus() {
		$(this.selectOnFocusClass).on('click', function () {
			$(this).select();
		})
	}

	notifyOnSuccess(event) {
		event.clearSelection();

		const notifyMessage = event.trigger.getAttribute('data-clipboard-notify-message');

		if (notifyMessage !== null) {
			this.notify.notify(notifyMessage, 'success');
		}
	}

	filterTextFromHtmlPreview() {
		$('.js-rte-preview-container *').each(function () {
			const element = $(this);

			if (element.html().replace(/\s|&nbsp;/g, '').length == 0) {
				element.remove();
			}
		})
	}

	initialize() {
		this.initializeClipboard();
		this.initializeHtmlClipboard();
		this.selectOnFocus();

		this.filterTextFromHtmlPreview();
	}
}



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/clipboard.js